import React from "react";
import MainContainer from "../../container/MainContainer";
import CouncilBanner from "./CouncilBanner";
import CouncilHeader from "./CouncilHeader";
import CouncilTab from "./CouncilTab";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { VIEW_PROFILE } from "../../query/ViewProfile";

const CouncilProfileLayout = () => {
  const { data } = useQuery(VIEW_PROFILE, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    client: hasuraClient,
  });
  return (
    <MainContainer active="councilProfile" className="edit-profile-main">
      <section className="council-cover">
        <CouncilBanner data={data} />
        <div className="council-row">
          <CouncilHeader data={data} />
          <CouncilTab />
        </div>
      </section>
    </MainContainer>
  );
};

export default CouncilProfileLayout;
